<script lang="ts">
  import { Button, Container } from "sveltestrap";
  import { Errorbtn, MAINTENANCE, href } from "../../../../../utils/Constant/Constant";
</script>
<section class="maintenance-sec">
    <div class="page-wrapper">
      <div class="error-wrapper maintenance-bg">
        <Container>
          <ul class="maintenance-icons">
            <li><i class="fa fa-cog"></i></li>
            <li><i class="fa fa-cog"></i></li>
            <li><i class="fa fa-cog"></i></li>
          </ul>
          <div class="maintenance-heading">
            <h2 class="headline">{MAINTENANCE}</h2>
          </div>
          <h4 class="sub-content">{'Our Site is Currently under maintenance We will be back Shortly'}<br>{'Thank You For Patience'}</h4>
          <div>
            <Button color="primary" class="btn-lg text-light" href={href}>{Errorbtn}</Button>
          </div>
        </Container>
      </div>
    </div>
</section>